import {Component, OnInit} from '@angular/core';
import {DataService} from 'projects/paid/src/app/components/publications/data.service';

@Component({
    selector: 'app-publications',
    templateUrl: './publications.component.html',
    styleUrls: ['./publications.component.scss']
})
export class PublicationsComponent implements OnInit {
    loading = true;
    posts: any[];

    constructor(
        private service: DataService
    ) {
    }

    ngOnInit(): void {
        this.service.fetchData()
            .subscribe((res: any[]) => {
                this.posts = res;
                this.loading = false;
            }, () => {
                this.loading = false;
            });
    }

    get showBlock() {
        return this.posts?.length && !this.loading;
    }

    findElementByHeaderPosition(position: number) {
        return this.posts.find(el => el.position === position.toString());
    }


}
